import { useState } from "react"
import { Button } from "@components/Button"
import { DocumentDownloadIcon, ChevronDownIcon } from "@assets/icons"
import { cn } from "src/utils/common.helper"

const DropdownButton = ({ onDownloadReports, onDownloadSummary }) => {
  const [showDropdown, setShowDropdown] = useState(false)
  const [selectedItem, setSelectedItem] = useState("Download Reports")

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev)
  }

  const handleItemClick = (item) => {
    setSelectedItem(item)
    setShowDropdown(false)
  }

  const handleButtonClick = () => {
    if (selectedItem === "Download Reports") {
      onDownloadReports()
    } else if (selectedItem === "Download Summary") {
      onDownloadSummary()
    }
  }

  return (
    <div
      className={`relative inline-block text-left w-full ${showDropdown ? "mb-52" : "mb-0"}`}
    >
      <div className="flex items-center w-full">
        <Button
          variant="primary"
          className="!text-xs !font-bold tracking-widest !rounded-r-none flex-grow"
          onClick={handleButtonClick}
        >
          <DocumentDownloadIcon className="text-[--pure-white]" />
          {selectedItem.toUpperCase()}
        </Button>
        <Button
          className="text-white !rounded-l-none !border-l !border-[#6195e2] flex-shrink-0"
          onClick={toggleDropdown}
        >
          <ChevronDownIcon className="text-[--pure-white]" />
        </Button>
      </div>
      {showDropdown && (
        <div className="absolute right-0 mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50 max-h-52 overflow-y-auto">
          <div className="py-1">
            <button
              onClick={() => handleItemClick("Download Reports")}
              className="block px-4 py-2 text-base text-gray-700 hover:bg-gray-100 w-full text-left"
            >
              <div>
                <div className="font-bold">Download Reports</div>
                <div className="text-sm text-gray-500">
                  Get detailed report in PDF
                </div>
              </div>
            </button>
            <button
              onClick={() => handleItemClick("Download Summary")}
              className="block px-4 py-2 text-base text-gray-700 hover:bg-gray-100 w-full text-left"
            >
              <div>
                <div className="font-bold">Download Summary</div>
                <div className="text-sm text-gray-500">
                  Get a total summary report in Excel
                </div>
              </div>
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default DropdownButton
